const actions = {
    GET_ALL_INVOICES_DATA: "invoices/GET_ALL_INVOICES_DATA",
    SET_ALL_INVOICES_DATA: "invoices/SET_ALL_INVOICES_DATA",

    GET_ALL_INVOICES_DATA_FILTER_MONTH: "invoices/GET_ALL_INVOICES_DATA_FILTER_MONTH",

    GET_INVOICES_DATA_FILTER_MONTH: "invoices/GET_INVOICES_DATA_FILTER_MONTH",

    GET_ALL_INVOICES_BY_WORKSPACE_DATA: "invoices/GET_ALL_INVOICES_BY_WORKSPACE_DATA",

    GET_INVOICES_DETAILS: "invoices/GET_INVOICES_DETAILS",
    SET_INVOICES_DETAILS: "invoices/SET_INVOICES_DETAILS",

    SET_INIT_INVOICES_DETAILS: "invoices/SET_INIT_INVOICES_DETAILS",

    GET_INVOICES_DETAILS_BY_ADMIN: "invoices/GET_INVOICES_DETAILS_BY_ADMIN",
    SET_INVOICES_DETAILS_BY_ADMIN: "invoices/SET_INVOICES_DETAILS_BY_ADMIN",

    SET_INITIAL_INVOICES_DATA: "invoices/SET_INITIAL_INVOICES_DATA"

};

export default actions;